import { Stack } from "@mantine/core";
import React, { useEffect } from "react";
import { MCApplicationsUrlEnum } from "@mcapps/shared/sharedConstants";
import { useGetProjectQuery } from "../../../projectRTK";
import { doLogUsage } from "../restQueries";
import AddNewMember from "./AddNewMember";
import MembersTable from "./MembersTable";

const MembersPage: React.FC<{ projectId: string }> = ({ projectId }) => {
  const { data: project } = useGetProjectQuery(projectId);

  useEffect(() => {
    if (project != null) {
      doLogUsage(project, MCApplicationsUrlEnum.MEMBERS, "open");
    }
  }, [project]);

  return (
    <Stack p="xs" gap={"xs"} w={"100%"} h={"100%"}>
      <AddNewMember />
      <MembersTable />
    </Stack>
  );
};

export default MembersPage;
